import ServiceHero from '@/components/sections/ServiceHero'

export default function InsightsHero() {
  return (
    <ServiceHero
      serviceName="Insights"
      titleLines={['Analytics that', 'lead to action']}
      description="We help you understand how visitors use your website — where they come from, what they do, and where they drop off. Clear reports and recommendations so you can make confident decisions instead of guessing."
    />
  )
}
